var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"boostergrid"}},[_c('FastbotTV',{attrs:{"id":"boostertv"}}),_c('FastbotList',{attrs:{"id":"boosterlist"}}),_c('FastbotPanel',{attrs:{"id":"boosterpanel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }